export enum ResourcePathsEnum {
  CROSSREFERENCE = '/crossreference/upload',
  CPA = '/cpa/',
}
